var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"d-flex justify-content-center h1"},[_vm._v(" Settings Vue ")])
}
var staticRenderFns = []

export { render, staticRenderFns }